import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=3b6350ff&scoped=true"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"
import style0 from "./Multiselect.vue?vue&type=style&index=0&id=3b6350ff&prod&scoped=true&lang=css"
import style1 from "./Multiselect.vue?vue&type=style&index=1&id=3b6350ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6350ff",
  null
  
)

export default component.exports